import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Form from '../../../../components/Form';
import Label from '../../../../components/Label';

import messages from './messages';
import '../styles.css';

const ErrorLabel = <Label role="tooltip" basic color="red" pointing><FormattedMessage {...messages.addressInvalidError} /></Label>;

const Address = ({ onChange, initialValue, formatMessage }) => {
  const showZipError = initialValue.zip.showError;
  const showFaxError = initialValue.fax.showError;
  const showPhoneError = initialValue.phoneNumber.showError;
  const showTollFreeError = initialValue.tollFreeNumber.showError;
  const showEmailError = initialValue.email.showError;

  return (
    <React.Fragment>
      <Form.Select
        label={formatMessage(messages.country)}
        placeholder={formatMessage(messages.country)}
        fluid
        lazyLoad
        selection
        search
        options={initialValue.country.options}
        value={initialValue.country.value}
        data-cy="Premium-Hem-contactInformation-Country-Dropdown"
        onChange={(e, { value }) => {
          onChange(e, { value }, 'country');
        }}
      />
      <Form.Select
        label={formatMessage(messages.state)}
        placeholder={formatMessage(messages.state)}
        fluid
        lazyLoad
        selection
        search
        options={initialValue.state.options}
        value={initialValue.state.value}
        data-cy="Premium-Hem-contactInformation-State-Dropdown"
        onChange={(e, { value }) => {
          onChange(e, { value }, 'state');
        }}
      />
      <Form.Input
        fluid
        label={formatMessage(messages.city)}
        placeholder={formatMessage(messages.city)}
        value={initialValue.city.value}
        data-cy="Premium-Hem-contactInformation-City-Input"
        onChange={(e, { value }) => {
          onChange(e, { city: { ...initialValue.city, value } });
        }}
        maxLength="255"
      />
      <Form.Field>
        <Form.Input
          fluid
          label={formatMessage(messages.zip)}
          placeholder={formatMessage(messages.zip)}
          value={initialValue.zip.value}
          data-cy="Premium-Hem-contactInformation-Zip-Input"
          onChange={(e, { value }) => {
            onChange(e, { zip: { ...initialValue.zip, value } });
          }}
          error={showZipError}
          styleName="error-field"
          maxLength="10"
        />
        {showZipError && ErrorLabel}
      </Form.Field>
      <Form.Input
        fluid
        label={formatMessage(messages.street)}
        placeholder={formatMessage(messages.street)}
        value={initialValue.street1.value}
        data-cy="Premium-Hem-contactInformation-Street1-Input"
        onChange={(e, { value }) => {
          onChange(e, { street1: { ...initialValue.street1, value } });
        }}
        maxLength="255"
      />
      <Form.Input
        fluid
        label={formatMessage(messages.street)}
        placeholder={formatMessage(messages.street)}
        value={initialValue.street2.value}
        data-cy="Premium-Hem-contactInformation-Street2-Input"
        onChange={(e, { value }) => {
          onChange(e, { street2: { ...initialValue.street2, value } });
        }}
        maxLength="255"
      />
      <Form.Field>
        <Form.Input
          fluid
          label={formatMessage(messages.email)}
          placeholder={formatMessage(messages.email)}
          value={initialValue.email.value}
          data-cy="Premium-Hem-contactInformation-Email-Input"
          onChange={(e, { value }) => {
            onChange(e, { email: { ...initialValue.email, value } });
          }}
          error={showEmailError}
          styleName="error-field"
          maxLength="100"
        />
        {showEmailError && ErrorLabel}
      </Form.Field>
      <Form.Field>
        <Form.Input
          fluid
          label={formatMessage(messages.fax)}
          placeholder={formatMessage(messages.fax)}
          value={initialValue.fax.value}
          data-cy="Premium-Hem-contactInformation-Fax-Input"
          onChange={(e, { value }) => {
            onChange(e, { fax: { ...initialValue.fax, value } });
          }}
          error={showFaxError}
          styleName="error-field"
          maxLength="20"
        />
        {showFaxError && ErrorLabel}
      </Form.Field>
      <Form.Field>
        <Form.Input
          fluid
          label={formatMessage(messages.phone)}
          placeholder={formatMessage(messages.phone)}
          value={initialValue.phoneNumber.value}
          data-cy="Premium-Hem-contactInformation-Phone-Input"
          onChange={(e, { value }) => {
            onChange(e, { phoneNumber: { ...initialValue.phoneNumber, value } });
          }}
          error={showPhoneError}
          styleName="error-field"
          maxLength="20"
        />
        {showPhoneError && ErrorLabel}
      </Form.Field>
      <Form.Field>
        <Form.Input
          fluid
          label={formatMessage(messages.tollFreePhone)}
          placeholder={formatMessage(messages.tollFreePhone)}
          value={initialValue.tollFreeNumber.value}
          data-cy="Premium-Hem-contactInformation-TollFreePhone-Input"
          onChange={(e, { value }) => {
            onChange(e, { tollFreeNumber: { ...initialValue.tollFreeNumber, value } });
          }}
          error={showTollFreeError}
          styleName="error-field"
          maxLength="20"
        />
        {showTollFreeError && ErrorLabel}
      </Form.Field>
      <Form.Input
        fluid
        label={formatMessage(messages.url)}
        placeholder={formatMessage(messages.url)}
        value={initialValue.url.value}
        data-cy="Premium-Hem-contactInformation-Url-Input"
        onChange={(e, { value }) => {
          onChange(e, { url: { ...initialValue.url, value } });
        }}
        maxLength="255"
      />
    </React.Fragment>
  );
};
Address.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default Address;
